import { useEffect, useState, useMemo } from "react";

import getAnnotationsCommentThread from "@/view/utils/getAnnotationsCommentThread";
import getIsLastCommentNotTheirOwn from "@/view/utils/getIsLastCommentNotTheirOwn";

const useAnnotationsCommentThread = ({
  shouldGetComments,
  comments,
  annotation,
  userId,
  deleteCommentButtonRef,
}) => {
  const commentThread = useMemo(() =>
    getAnnotationsCommentThread(shouldGetComments, comments, annotation.id),
  );
  const commentThreadLength = commentThread?.length;
  const latestCommentInThread =
    commentThreadLength && commentThread[commentThreadLength - 1];
  const lastCommentIsNotTheirOwn = getIsLastCommentNotTheirOwn(
    commentThreadLength,
    annotation,
    userId,
    latestCommentInThread,
  );
  const [numberOfCommentsInThread, setNumberOfCommentsInThread] =
    useState(commentThreadLength);

  useEffect(() => {
    setNumberOfCommentsInThread(commentThreadLength);

    // Delaying focus to allow the card to re-render after
    // updating reply mode state
    setTimeout(() => {
      deleteCommentButtonRef?.current?.focus();
    }, 50);
  }, [commentThread]);

  return {
    commentThread,
    latestCommentInThread,
    lastCommentIsNotTheirOwn,
    numberOfCommentsInThread,
  };
};

export default useAnnotationsCommentThread;
